import * as XLSX from "xlsx";
export const excelExport = (data, reportName) => {
  const transformedData = data.map((item) => {
    return Object.keys(item).reduce((acc, cur) => {
      const key = cur.charAt(0).toUpperCase() + cur.slice(1);
      acc[key] = item[cur];
      return acc;
    }, {});
  });

  const date = new Date().toLocaleDateString();
  const ws = XLSX.utils.json_to_sheet(transformedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, reportName);
  XLSX.writeFile(wb, `${reportName}_Report_${date}.xlsx`);
};
